import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MatDialog} from '@angular/material/dialog';
import { EstadisticasComponent } from 'app/modals/estadisticas/estadisticas.component';
import { EstadisticasServicioMedicoService } from 'app/services/estadisticas/estadisticas-servicio-medico.service';
import { ServiciosService } from '../../../services/servicios.service';

@Component({
  selector: 'app-dashboard-servicio-medico',
  templateUrl: './dashboard-servicio-medico.component.html',
  styleUrls: ['./dashboard-servicio-medico.component.scss']
})
export class DashboardServicioMedicoComponent implements OnInit {

    private fechaFinal: string;
    private fechaInicial: string;
    public fecha_final: any = moment()
    public fecha_inicial:any = moment()

    public codigosAmarillos;
    public codigosAmarillos2;
    public codigosRojos;
    public codigosRojos2;
    public codigosVerdes;
    public codigosVerdes2;
    public totalServicios;
    public totalServicios2;
    public serviciosCancelados;
    public serviciosCancelados2;
    public traslado;
    public traslado2;
    public pasadasdetiempo;
    public pasadasdetiempo2;
    public equivocadas;
    public equivocadas2;
    public manuales;
    public manuales2;
    public conlaApp;
    public conlaApp2;
    public trasladoprogramado;
    public trasladoprogramado2;
    public consultasactivas;
    public consultasactivas2;
    public masde100;
    public masde100_2;

    constructor(private servicios: EstadisticasServicioMedicoService,
                private dialog: MatDialog,
                private serviciosService:ServiciosService) { }

    ngOnInit() {
      this.newEstadisticas()
    }

    reloadEstadisticas(){
        this.newEstadisticas();
    }

    buscar(){

        // tslint:disable-next-line: max-line-length
        this.fechaInicial = moment(this.fecha_inicial).get('year').toString()+"-"+(moment(this.fecha_inicial).get('month')+1).toString()+"-"+moment(this.fecha_inicial).get('date').toString();
        // tslint:disable-next-line: max-line-length
        this.fechaFinal = moment(this.fecha_final).get('year').toString() +"-"+(moment(this.fecha_final).get('month')+1).toString() +"-"+ moment(this.fecha_final).get('date').toString();

        this.servicios.codigosAmarillos(this.fechaInicial,this.fechaFinal).subscribe((data)=>{
            this.codigosAmarillos = Object.keys(data).length;
            this.codigosAmarillos2 = data;
        })

        this.servicios.codigosRojos(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.codigosRojos = Object.keys(data).length;
            this.codigosRojos2 = data;
        })

        this.servicios.codigosVerdes(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.codigosVerdes = Object.keys(data).length;
            this.codigosVerdes2 = data;
        })

        this.servicios.totalServiciosDia(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.totalServicios = Object.keys(data).length;
            this.totalServicios2 = data;
        })

        this.servicios.servicioscancelados(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.serviciosCancelados = Object.keys(data).length;
            this.serviciosCancelados2 = data;
        })

        this.servicios.servicioscontraslado(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.traslado = Object.keys(data).length;
            this.traslado2 = data;
        })

        this.servicios.pasadasDetiempo(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.pasadasdetiempo = Object.keys(data).length;
            this.pasadasdetiempo2 = data;
        })

        this.servicios.equivocadas(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.equivocadas = Object.keys(data).length;
            this.equivocadas2 = data;
        })

        this.servicios.manuales(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.manuales = Object.keys(data).length;
            this.manuales2 = data;
        })

        this.servicios.conlaApp(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.conlaApp = Object.keys(data).length;
            this.conlaApp2 = data;
        })

        this.servicios.trasladoprogramado(this.fechaInicial,this.fechaFinal).subscribe((data) => {
            this.trasladoprogramado = Object.keys(data).length;
            this.trasladoprogramado2 = data;
        })

        this.servicios.masde100(this.fechaInicial,this.fechaFinal).subscribe((data)=>{
            this.masde100 =  Object.keys(data).length;
            this.masde100_2 = data;
        })
    }

    estadisticas(param){
      switch (param) {
        case 1:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Servicios del Dia',
              servicios: this.totalServicios2,
              width:'100%',
              datos:'con exel'
            }
          })
          break;
        case 6:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas En Traslado',
              servicios: this.traslado2,
              datos:'con exel',
            }
          })
          break;
        case 7:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Con Traslado Programado',
              servicios: this.trasladoprogramado2,
              datos:'con exel',
            }
          })
          break;
        case 8:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Canceladas',
              servicios: this.serviciosCancelados2,
              datos:'con exel',
            }
          })
          break;
        case 9:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas De Mas De 4 Horas',
              servicios: this.pasadasdetiempo2,
              datos:'con exel',
            }
          })
          break;
        case 10:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Mas De 100%',
              servicios: this.masde100_2,
              datos:'con exel',
              width:'100%'
            }
          })
          break;
        case 11:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Manuales',
              servicios: this.manuales2,
              datos:'con exel',
              tipo:'manual'
            }
          })
          break;
        case 12:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Con La Aplicacion',
              servicios: this.conlaApp2,
              datos:'con exel',
            }
          })
          break;
        case 13:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Equivocadas',
              servicios: this.equivocadas2,
              datos:'con exel',
            }
          })
          break;
        case 14:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Con Codigo Verde',
              servicios: this.codigosVerdes2,
              datos:'con exel',
            }
          })
          break;
        case 15:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Con Codigo Amarillo',
              servicios: this.codigosAmarillos2,
              datos:'con exel',
            }
          })
          break;
        case 16:
          this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Con Codigo Rojo',
              servicios: this.codigosRojos2,
              datos:'con exel',
            }
          })
          break;
      }
    }

    newEstadisticas(){

        this.servicios.codigosAmarillos(0,0).subscribe((data)=>{
            this.codigosAmarillos = Object.keys(data).length;
            this.codigosAmarillos2 = data;
        })

        this.servicios.codigosRojos(0,0).subscribe((data) => {
        this.codigosRojos = Object.keys(data).length;
        this.codigosRojos2 = data;
        })

        this.servicios.codigosVerdes(0,0).subscribe((data) => {
            this.codigosVerdes = Object.keys(data).length;
            this.codigosVerdes2 = data;
        })

        this.servicios.totalServiciosDia(0,0).subscribe((data) => {
            this.totalServicios = Object.keys(data).length;
            this.totalServicios2 = data;
        })

        this.servicios.servicioscancelados(0,0).subscribe((data) => {
            this.serviciosCancelados = Object.keys(data).length;
            this.serviciosCancelados2 = data;
        })

        this.servicios.servicioscontraslado(0,0).subscribe((data) => {
            this.traslado = Object.keys(data).length;
            this.traslado2 = data;
        })

        this.servicios.pasadasDetiempo(0,0).subscribe((data) => {
            this.pasadasdetiempo = Object.keys(data).length;
            this.pasadasdetiempo2 = data;
        })

        this.servicios.equivocadas(0,0).subscribe((data) => {
            this.equivocadas = Object.keys(data).length;
            this.equivocadas2 = data;
        })

        this.servicios.manuales(0,0).subscribe((data) => {
            this.manuales = Object.keys(data).length;
            this.manuales2 = data;
        })

        this.servicios.conlaApp(0,0).subscribe((data) => {
            this.conlaApp = Object.keys(data).length;
            this.conlaApp2 = data;
        })

        this.servicios.trasladoprogramado(0,0).subscribe((data) => {
            this.trasladoprogramado = Object.keys(data).length;
            this.trasladoprogramado2 = data;
        })

        this.servicios.masde100(0,0).subscribe((data)=>{
            this.masde100 =  Object.keys(data).length;
            this.masde100_2 = data;
        })
    }

  }

